import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ThemeContext } from '../context/ThemeContext';
import { FaHome, FaCog, FaSun, FaMoon, FaSignOutAlt } from 'react-icons/fa';
import styles from './Header.module.css';

const Header = () => {
    const { logout } = useContext(AuthContext);
    const { theme, toggleTheme } = useContext(ThemeContext);

    return (
        <header className={`${styles.header} ${styles[theme]}`}>
            <div className={styles['header-content']}>
                <div className={styles['header-left']}>
                    <Link to="/" className={styles.iconLink}>
                        <FaHome />
                        <span className={styles.iconLabel}>Home</span>
                    </Link>
                    <span className={styles.appName}>Admin Dashboard</span>
                </div>
                <div className={styles['header-right']}>
                    <Link to="/settings" className={styles.iconLink}>
                        <FaCog />
                        <span className={styles.iconLabel}>Settings</span>
                    </Link>
                    <div className={styles.iconLink} onClick={toggleTheme}>
                        {theme === 'dark' ? <FaMoon /> : <FaSun />}
                        <span className={styles.iconLabel}>Theme</span>
                    </div>
                    <button onClick={logout} className={`${styles.iconLink} ${styles.logoutButton}`}>
                        <FaSignOutAlt />
                        <span className={styles.iconLabel}>Logout</span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
